import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';
import { ComponentType } from 'react';

import StandardTag from './StandardTag.layout';
import { StandardTagOwnProps } from './StandardTag.types';


const decorate = compose<ComponentType<StandardTagOwnProps>>(
    withTranslation('common'),
);

export default decorate(StandardTag);
